module.exports = __webpack_public_path__ + "img/caselist27.d49cdd63.jpg";